<script setup lang="ts">
const { t } = useI18n()
const isShow = ref(false)
const open = () => {
  isShow.value = true
}
const close = () => {
  isShow.value = false
  GlobalThis.$getRewards?.open()
}
defineExpose({ open, close })
</script>

<template>
  <div
    v-if="isShow"
    class="bg-white dark:bg-brand flex flex-col overflow-hidden fixed top-0 left-0 z-99999 w-screen h-screen pb-14.5 px-8"
  >
    <n-carousel autoplay>
      <div class="w-full relative flex flex-col items-center justify-between">
        <img src="@/assets/telegram/1.webp" class="w-37.5 mt-25" alt="dfans" />
        <div class="text-7 leading-8 typeface-robotoMedium mt-10">
          {{ t('Global.WelcomeToDFans') }}!
        </div>
        <div class="text-base mt-2 text-center">
          {{ t('Telegram.desc1') }}
        </div>
      </div>
      <div class="w-full relative flex flex-col items-center justify-between">
        <img src="@/assets/telegram/2.webp" class="w-37.5 mt-25" alt="dfans" />
        <div class="text-7 leading-8 typeface-robotoMedium mt-10 text-center">
          {{ t('Telegram.desc2') }}
        </div>
      </div>
      <div class="w-full px-2 relative flex flex-col items-center justify-between">
        <img src="@/assets/telegram/1.webp" class="w-37.5 mt-25" alt="dfans" />
        <div class="text-7 leading-8 typeface-robotoMedium mt-10 text-center px-3">
          {{ t('Global.desc4') }}
        </div>
        <div class="text-base mt-2 text-center">
          {{ t('Telegram.desc3') }}
        </div>
      </div>
      <template #dots="{ total, currentIndex, to }">
        <div class="custom-dots flex items-center justify-center absolute-center top-65vh">
          <div
            v-for="index of total"
            :key="index"
            :class="{ ['is-active']: currentIndex === index - 1 }"
            class="w-4 h-1.5 mx-1 rounded-full bg-brandB bg-op-15 cursor-pointer"
            @click="to(index - 1)"
          />
        </div>
      </template>
    </n-carousel>
    <DfansButton
      :text="t('Btn.LetsGetStarted')"
      class="w-full !text-base h-12 mt-auto !rounded-3 mt-auto"
      type="default"
      @click="close"
    />
  </div>
</template>

<style lang="less" scoped>
.custom-dots li {
  transition:
    width 0.3s,
    background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.custom-dots li.is-active {
  background: #fff;
}
</style>
